import * as React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { useCallback } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import AnimatedSection, { AnimatedGrid } from '../AnimatedSection';
import styles from './index.module.scss';
import Arrow from './arrow';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import gtm from '@/utils/gtm';

const OnePicture: React.FC = () => {
    const { t } = useLang('OnePicture');
    const PRODUCT_IMAGE_URL_HAVE = 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg';

    const items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758770924787-zmy0hl-compressed-11111%201.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758877753060-mzkq9m-compressed-Frame%201612707998.jpg',
            href: '#videoSection1',
        },
        {
            title: t.rich('title2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758333686057-wscw5p-compressed-Frame%201612708200.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758333686057-wscw5p-compressed-Frame%201612708200.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758878191762-5vzgu3-compressed-Frame%201000008645.jpg',
            href: '#Power',
        },
        {
            title: t('title3'),
            desc: t('desc3'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758333710481-yyim8v-compressed-Frame%201612708201.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758333710481-yyim8v-compressed-Frame%201612708201.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758887752496-r09tv0-compressed-Frame%201000008654.jpg',
            href: '#Output',
        },
        {
            title: t.rich('title4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc4'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758771832444-xxvsvb-compressed-Frame%201612708208.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758771832444-xxvsvb-compressed-Frame%201612708208.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758878253470-7lpgi3-compressed-Frame%201000008978.jpg',
            href: '#LFP',
        },
        {
            title: t('title5'),
            desc: t('desc5'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758333751268-jst6rm-compressed-Frame%202094654388.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758333751268-jst6rm-compressed-Frame%202094654388.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758878295824-1gyen9-compressed-Frame%201000008654.jpg',
            href: '#videoSection3',
        },
        {
            title: t('title6'),
            desc: t('desc6'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758333776489-4ksmsy-compressed-Frame%201612708205.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758333776489-4ksmsy-compressed-Frame%201612708205.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758878311576-m0nkc7-compressed-Frame%201000008978.jpg',
            href: '#Built',
        },
        {
            title: t('title7'),
            desc: t('desc7'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758333796237-5ieln2-compressed-Frame%201612708203.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758333796237-5ieln2-compressed-Frame%201612708203.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758878356601-0iasu5-compressed-Frame%201612707627.jpg',
        },
    ];

    const { isPad, isH5 } = useDeviceDetect();
    React.useEffect(() => {
        const imgHave = new Image();
        imgHave.crossOrigin = 'anonymous';
        imgHave.onload = () => {
            /* 预加载完成 */
        };
        imgHave.onerror = () => {
            /* 预加载失败 */
        };
        imgHave.src = PRODUCT_IMAGE_URL_HAVE;

        if (isPad || isH5) {
            const onePictureElm = document.getElementById('OnePicture');
            if (onePictureElm) onePictureElm.style.opacity = '1';
            return;
        }

        // 监听VideoFrame组件的进度事件
        const handleVideoProgress95 = (data: { progress: number }) => {
            console.log('OnePicture收到VideoFrame进度事件:', data.progress);
            setHaveProductImage(true);
        };

        EcoDesignEventsBus.on('videoProgress95', handleVideoProgress95);

        // 清理事件监听器
        return () => {
            EcoDesignEventsBus.off('videoProgress95', handleVideoProgress95);
        };
    }, [isPad, isH5]);

    const [haveProductImage, setHaveProductImage] = React.useState(false);

    const handleScrollInToView = useCallback((href: string) => {
        if (!href) return;

        const elementId = href.replace('#', '');
        const element = document.getElementById(elementId);

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            const targetIdx = items.findIndex((item) => item.href === href);
            gtm.push({
                __btn_id1: `${styles.OnePicture} .item-${targetIdx + 1}`,
                __btn_id2: 'animated-section',
                __btn_type: 'common',
            });
        } else {
            console.warn(`Element with id "${elementId}" not found`);
        }
    }, []);

    return (
        <div className={`${styles.OnePicture} d3m-layout range1`} id="OnePicture">
            <AnimatedSection
                variant="rotateIn"
                options={{ delay: 200 }}
                data-btn-id="animated-section"
                onClick={() => {
                    handleScrollInToView(items[0].href || '');
                }}
                className="item item-1"
            >
                {!haveProductImage && <EcoImg key={1} pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                {haveProductImage && <EcoImg key={2} pc={PRODUCT_IMAGE_URL_HAVE} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />}
                {/* <EcoImg pc={items[0].pc} pad={items[0].pad} h5={items[0].h5} /> */}
                <div className="text-wrapper">
                    <div className="title">{items[0].title}</div>
                    <div className="desc">{items[0].desc}</div>
                </div>
                <div
                    className="arrow"
                    onClick={() => {
                        handleScrollInToView(items[0].href || '');
                    }}
                >
                    <Arrow />
                </div>
            </AnimatedSection>

            <div className="item-2">
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 200 }}
                    onClick={() => {
                        handleScrollInToView(items[1].href || '');
                    }}
                    className="item item-2-1"
                >
                    <EcoImg pc={items[1].pc} pad={items[1].pad} h5={items[1].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[1].title}</div>
                        <div className="desc">{items[1].desc}</div>
                    </div>
                    <div className="arrow">
                        <Arrow />
                    </div>
                </AnimatedSection>
                <AnimatedSection variant="rotateIn" options={{ delay: 200 }} className="item-2-2">
                    <div
                        className="item item-2-2-1"
                        onClick={() => {
                            handleScrollInToView(items[2].href || '');
                        }}
                    >
                        <EcoImg pc={items[2].pc} pad={items[2].pad} h5={items[2].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[2].title}</div>
                            <div className="desc">{items[2].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                    <div
                        className="item item-2-2-2"
                        onClick={() => {
                            handleScrollInToView(items[3].href || '');
                        }}
                    >
                        <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[3].title}</div>
                            <div className="desc">{items[3].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                </AnimatedSection>
            </div>
            <div className="item-3">
                <AnimatedGrid variant="rotateIn" options={{ delay: 100, stagger: 0.2 }} className="item-3-1">
                    <div className="item item-3-1-1">
                        <EcoImg pc={items[4].pc} pad={items[4].pad} h5={items[4].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[4].title}</div>
                            <div className="desc">{items[4].desc}</div>
                        </div>
                        {/* <div
                            className="arrow"
                            onClick={() => {
                                handleScrollInToView(items[4].href || '');
                            }}
                        >
                            <Arrow />
                        </div> */}
                    </div>
                    <div
                        className="item item-3-1-2"
                        onClick={() => {
                            handleScrollInToView(items[5].href || '');
                        }}
                    >
                        <EcoImg pc={items[5].pc} pad={items[5].pad} h5={items[5].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[5].title}</div>
                            <div className="desc">{items[5].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                </AnimatedGrid>
                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 100 }}
                    className={'item item-3-2'}
                    onClick={() => handleScrollInToView(items[6].href || '')}
                >
                    <EcoImg pc={items[6].pc} pad={items[6].pad} h5={items[6].h5} isOpenLazy={true} />
                    <div className="text-wrapper">
                        <div className="title">{items[6].title}</div>
                        <div className="desc">{items[6].desc}</div>
                    </div>
                </AnimatedSection>
            </div>
        </div>
    );
};

export default OnePicture;
